import localFont from './localFont';

type FontType = {
  label: string;
  value: string;
  variable: string | undefined;
};

const Abraham = localFont({
  variable: '--font-abraham',
  src: [
    {
      path: './Abraham/Abraham-Bold.woff2',
      weight: '700',
      style: 'normal'
    },
    {
      path: './Abraham/Abraham-Medium.woff2',
      weight: '500',
      style: 'normal'
    },
    {
      path: './Abraham/Abraham-Regular.woff2',
      weight: '400',
      style: 'normal'
    }
  ],
  preload: true
});

const Alef = localFont({
  variable: '--font-alef',
  src: [
    {
      path: './Alef/Alef-Bold.woff2',
      weight: '700',
      style: 'normal'
    },
    {
      path: './Alef/Alef-Regular.woff2',
      weight: '400',
      style: 'normal'
    }
  ],
  preload: true
});

const Arial = localFont({
  variable: '--font-arial',
  src: [
    {
      path: './Arial/Arial-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './Arial/Arial-Bold.woff2',
      weight: '700',
      style: 'normal'
    },
    {
      path: './Arial/Arial-ItalicRegular.woff2',
      weight: '400',
      style: 'italic'
    },
    {
      path: './Arial/Arial-ItalicBold.woff2',
      weight: '700',
      style: 'italic'
    }
  ],
  preload: false
});

const Almoni = localFont({
  variable: '--font-almoni',
  src: [
    {
      path: './Almoni/Almonineue-Bold.woff2',
      weight: '700',
      style: 'normal'
    },
    {
      path: './Almoni/Almonineue-Demibold.woff2',
      weight: '600',
      style: 'normal'
    },
    {
      path: './Almoni/Almonineue-Medium.woff2',
      weight: '500',
      style: 'normal'
    },
    {
      path: './Almoni/Almonineue-Regular.woff2',
      weight: '400',
      style: 'normal'
    }
  ],
  preload: true
});

const Arimo = localFont({
  variable: '--font-arimo',
  src: [
    {
      path: './Arimo/Arimo-VariableFont_wght.woff2',
      style: 'normal'
    },
    {
      path: './Arimo/Arimo-Italic-VariableFont_wght.woff2',
      style: 'italic'
    }
  ],
  preload: true
});

const Assistant = localFont({
  variable: '--font-assistant',
  src: [
    {
      path: './Assistant/Assistant-VariableFont_wght.woff2',
      style: 'normal'
    }
  ],
  preload: false
});

const Heebo = localFont({
  variable: '--font-heebo',
  src: [
    {
      path: './Heebo/Heebo-VariableFont_wght.woff2',
      style: 'normal'
    }
  ],
  preload: false
});

const Lateef = localFont({
  variable: '--font-lateef',
  src: [
    {
      path: './Lateef/Lateef-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './Lateef/Lateef-Bold.woff2',
      weight: '700',
      style: 'normal'
    }
  ],
  preload: false
});

const KtivaTama = localFont({
  variable: '--font-ktivaTama',
  src: [
    {
      path: './KtivaTama/KtivaTama-Medium.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './KtivaTama/KtivaTama-Bold.woff2',
      weight: '700',
      style: 'normal'
    }
  ],
  preload: false
});

const NotoSans = localFont({
  variable: '--font-notoSans',
  src: [
    {
      path: './NotoSans/NotoSans-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './NotoSans/NotoSans-Bold.woff2',
      weight: '700',
      style: 'normal'
    }
  ],
  preload: false
});

const Poppins = localFont({
  variable: '--font-poppins',
  src: [
    {
      path: './Poppins/Poppins-Bold.woff2',
      weight: '700',
      style: 'normal'
    },
    {
      path: './Poppins/Poppins-Medium.woff2',
      weight: '500',
      style: 'normal'
    },
    {
      path: './Poppins/Poppins-Regular.woff2',
      weight: '400',
      style: 'normal'
    }
  ]
});

const OpenSansHebrew = localFont({
  variable: '--font-openSansHebrew',
  src: [
    {
      path: './OpenSansHebrew/OpenSansHebrew-Light.woff2',
      weight: '300',
      style: 'normal'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-Bold.woff2',
      weight: '700',
      style: 'normal'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-ExtraBold.woff2',
      weight: '800',
      style: 'normal'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-ItalicLight.woff2',
      weight: '300',
      style: 'italic'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-ItalicRegular.woff2',
      weight: '400',
      style: 'italic'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-ItalicBold.woff2',
      weight: '700',
      style: 'italic'
    },
    {
      path: './OpenSansHebrew/OpenSansHebrew-ItalicExtraBold.woff2',
      weight: '800',
      style: 'italic'
    }
  ],
  preload: false
});

const TraditionalArabic = localFont({
  variable: '--font-traditionalArabic',
  src: [
    {
      path: './TraditionalArabic/TraditionalArabic-Regular.woff2',
      weight: '400',
      style: 'normal'
    },
    {
      path: './TraditionalArabic/TraditionalArabic-Bold.woff2',
      weight: '700',
      style: 'normal'
    }
  ],
  preload: false
});

const fonts: FontType[] = [
  { value: 'var(--font-abraham)', label: 'Abraham', variable: Abraham.variable },
  { value: 'var(--font-alef)', label: 'Alef', variable: Alef.variable },
  { value: 'var(--font-arial)', label: 'Arial', variable: Arial.variable },
  { value: 'var(--font-almoni)', label: 'Almoni', variable: Almoni.variable },
  { value: 'var(--font-arimo)', label: 'Arimo', variable: Arimo.variable },
  { value: 'var(--font-assistant)', label: 'Assistant', variable: Assistant.variable },
  { value: 'var(--font-heebo)', label: 'Heebo', variable: Heebo.variable },
  { value: 'var(--font-lateef)', label: 'Lateef', variable: Lateef.variable },
  { value: 'var(--font-ktivaTama)', label: 'KtivaTama', variable: KtivaTama.variable },
  { value: 'var(--font-notoSans)', label: 'NotoSans', variable: NotoSans.variable },
  { value: 'var(--font-openSansHebrew)', label: 'OpenSansHebrew', variable: OpenSansHebrew.variable },
  { value: 'var(--font-poppins)', label: 'Poppins', variable: Poppins.variable },
  { value: 'var(--font-traditionalArabic)', label: 'TraditionalArabic', variable: TraditionalArabic.variable }
];

export { fonts };
